import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	tooltipMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tooltipMessage: {
		id: 'filter-refinement.search-field.tooltip-message',
		defaultMessage: 'Search <inline>F</inline>',
		description:
			'Tooltip message shown when hovering over the search field, indicating the keyboard shortcut F to focus on search field',
	},
});
export default messages;
